module.exports = __webpack_public_path__ + "img/telecommunications_logo.5e6e1bf4.png";